import { Icon } from '@iconify/react/dist/iconify.js'
import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { ConfigContext } from '../context/GlobalContext';
import * as actionType from "../context/actions";
import LoaderView from './LoaderView';
import { CreateSubscription } from '../data/Payment/CreateSubscription';
import { HandlePayment } from '../data/Payment/HandlePayment';
import { trackEvent, trackSubscriptionViewed, trackPlanSelected, trackSubscriptionInitiated } from '../Utils/EventTracker';
import MessageModel from './MessageModel';
import { CreateNewCustomer } from '../data/Firebase/Authentication/CreateNewCustomer';
import EditUserDataInFirebase from '../data/Firebase/User/EditUserDataInFirebase';
import ReactGA from '../Utils/analytics';
import { logEvent } from '../helper/shakebug';

const PricingPlanLayer = () => {

    const { state, dispatch } = useContext(ConfigContext);

    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("INR");
    const [isLoading, setIsLoading] = useState(false);
    let Type;
    const latestPayment = [...(state?.PAYMENT || [])]
        .sort((a, b) => {
            const dateA = Number(a?.lastDate?.length > 10 ? a?.lastDate : a?.lastDate * 1000 || 0);
            const dateB = Number(b?.lastDate?.length > 10 ? b?.lastDate : b?.lastDate * 1000 || 0);
            return dateB - dateA;
        })[0];

    const currentPlanName = latestPayment?.planName || "Free Plan";


    const getBadge = (plan) => {
        if (!state?.PREMIUM) {
            return "";
        } else if (plan === currentPlanName) {
            return "Current Plan";
        }
        return null;
    };

    useEffect(() => {
        // GA4: track pricing page view
        trackSubscriptionViewed(state?.USERID, activeTab);

        const handleTabChange = (event) => {
            const activeTabId = event.target.id; // Get the ID of the clicked tab
            setActiveTab(activeTabId === "pills-monthly-tab" ? "INR" : "USD");
        };

        const tabs = document.querySelectorAll('[data-bs-toggle="pill"]');
        tabs.forEach((tab) => tab.addEventListener("shown.bs.tab", handleTabChange));

        return () => {
            tabs.forEach((tab) => tab.removeEventListener("shown.bs.tab", handleTabChange));
        };
    }, []);

    const handleSubscriptionAndPayment = async (planId, type) => {

        ReactGA.gtag("event", "begin_checkout", {
            plan_name: type,
            currency: activeTab,
        });

        setIsLoading(true);
        const data = {
            email: state?.SET_USER?.email,
            name: state?.SET_USER?.name,
            desc: `This is ${type} subscription.`
        };
        localStorage.setItem("type", type);
        Type = localStorage.getItem("type");

        // GA4: plan selected / begin_checkout
        trackPlanSelected(`${type} Plan`, planId, activeTab, state?.USERID);

        // ShakeBug: unique event per plan selection
        logEvent("premium_purchased", state?.USERID);


        try {

            let customerID = null;

            if (state?.SET_USER?.razorpayId) {
                customerID = state?.SET_USER?.razorpayId
            }
            else {
                const result = await CreateNewCustomer(state?.SET_USER?.name, state?.SET_USER?.email, state?.SET_USER?.contact, state?.USERID);

                customerID = result;

                const userData = {
                    social_id: state?.SET_USER?.social_id,
                    name: data?.name,
                    email: data?.email,
                    contact: state?.SET_USER?.contact,
                    currency: state?.SET_USER?.currency || 'IND',
                    user_uid: state?.SET_USER?.user_uid || '',
                    platform: state?.SET_USER?.platform,
                    razorpayId: result,
                }

                EditUserDataInFirebase(state, dispatch, state?.USERID, userData)
            }

            const subscriptionId = await CreateSubscription(planId, state?.USERID, customerID);
            if (subscriptionId) {
                // GA4: subscription created, Razorpay modal opening
                trackSubscriptionInitiated(`${type} Plan`, subscriptionId, state?.USERID);
                HandlePayment(subscriptionId, state, dispatch, setIsLoading, navigate, data);
            }
        }
        catch (error) {
            trackEvent("API_FAILED", { 'name': "create-subscription", "error": error })
        }
    };

    const PricingCard = ({ bgClass, title, price, subtitle, items, buttonLabel, onClick, badgeLabel }) => (
        <div className="col">
            <div className={`pricing-plan position-relative radius-24 overflow-hidden border ${bgClass} h-100 d-flex flex-column`}>



                {/* Responsive container for title, price, and badge */}
                <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">

                    <p className="fw-600 mb-0">{title}</p>

                    {badgeLabel && (
                        <span
                            className="position-absolute d-flex align-items-center gap-1 bg-danger text-white px-3 py-1 rounded-pill fw-semibold shadow-sm"
                            style={{
                                top: "14px",
                                right: "14px",
                                fontSize: "10px",
                                letterSpacing: "0.5px",
                            }}
                        >
                            {/* ⭐ Yellow Star */}
                            <Icon icon="mdi:star" color="#FFD700" width={12} height={12} />
                            {badgeLabel}
                        </span>
                    )}
                </div>

                <div className="mb-3 mt-2 d-flex align-items-end">
                    <h3 className="mb-0 fw-bold">{price}</h3>
                    {subtitle && (
                        <span
                            className="text-secondary-light ms-2"
                            style={{ fontSize: "14px", marginBottom: "4px" }}
                        >
                            {subtitle}
                        </span>
                    )}
                </div>


                <span className="mb-20 fw-medium">What’s included</span>
                <ul className="list-unstyled m-0 p-0">
                    {items.map((item, index) => (
                        <li key={index} className="d-flex align-items-center mb-3">
                            <div
                                className="d-flex justify-content-center align-items-center bg-primary rounded-circle"
                                style={{ width: '24px', height: '24px', minWidth: '24px' }}
                            >
                                <Icon
                                    icon="iconamoon:check-fill"
                                    color="#ffffff"
                                    width={14}
                                    height={14}
                                    style={{ display: 'block' }}
                                />
                            </div>
                            <span className="ms-3 text-secondary-light fs-6">{item}</span>
                        </li>
                    ))}
                </ul>
                <div className="mt-auto">
                    {buttonLabel && (
                        <button
                            onClick={onClick}
                            className="bg-primary bg-hover-primary-dark text-white text-center border border-primary text-sm btn-sm px-12 py-10 w-100 radius-8 mb-1"
                        >
                            {buttonLabel}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
    useEffect(() => {
        ReactGA.event("visit_page", {
            page: "pricing",
        });
    }, [])

    return (
        <div className="card h-100 p-0 radius-12 overflow-hidden">

            {isLoading && (
                <LoaderView />
            )}
            <div className="card-body">
                <div className="row justify-content-center">
                    <div className="col-xxl-12 mt-3">
                        <div className="mb-4">
                            {/* Title */}
                            <div className="text-center mb-2">
                                {/* <h5 className="mb-0">Choose Your Perfect Plan</h5> */}
                            </div>

                            {/* Subtitle + Toggle Row */}
                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">

                                {/* LEFT SIDE */}
                                <div>
                                    <h5 className="mb-1">Choose Your Perfect Plan</h5>
                                    <p className="mb-0 text-secondary-light">
                                        No Contracts. No Surprise Fees.
                                    </p>
                                </div>

                                {/* RIGHT SIDE - Toggle */}
                                <ul
                                    className="nav nav-pills button-tab pricing-tab"
                                    id="pills-tab"
                                    role="tablist"
                                >
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link px-24 py-10 text-md rounded-pill text-secondary-light fw-medium active"
                                            id="pills-monthly-tab"
                                            data-bs-toggle="pill"
                                            data-bs-target="#pills-monthly"
                                            type="button"
                                        >
                                            INR
                                        </button>
                                    </li>

                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link px-24 py-10 text-md rounded-pill text-secondary-light fw-medium"
                                            id="pills-yearly-tab"
                                            data-bs-toggle="pill"
                                            data-bs-target="#pills-yearly"
                                            type="button"
                                        >
                                            USD
                                        </button>
                                    </li>
                                </ul>

                            </div>


                        </div>


                        <div className="tab-content" id="pills-tabContent" style={{ marginTop: 30 }}>
                            {/* INR PLANS */}
                            <div
                                className={`tab-pane fade show ${activeTab === "INR" ? "active" : ""}`}
                                id="pills-monthly"
                                role="tabpanel"
                                aria-labelledby="pills-monthly-tab"
                                tabIndex={0}
                            >
                                <div className="row justify-content-center g-4">
                                    {/* Free Plan (UNCHANGED) */}
                                    <PricingCard
                                        bgClass="bg-card-light-pink"
                                        title="Free Plan"
                                        price="Free"
                                        subtitle=""
                                        items={[
                                            "1 Business",
                                            "2 invoices per month",
                                            "Unlimited expenses",
                                            "Limited invoice previews"
                                        ]}
                                        buttonLabel="Try for Free"
                                        onClick={() => navigate("/dashboard")}
                                        badgeLabel={currentPlanName === "Free" ? "✅ Current Plan" : null}
                                    />

                                    {/* Starter Plan */}
                                    <PricingCard
                                        bgClass="bg-card-light-green"
                                        title="Starter Plan"
                                        price="Rs.499"
                                        subtitle="/year"
                                        items={[
                                            "1 Business",
                                            "Unlimited Invoices",
                                            "Unlimited Quotations",
                                            "Unlimited Proforma Invoices",
                                            "Unlimited Previews",
                                            "BillNama Branding",
                                            "WhatsApp Share",
                                            "Customer Ledger",
                                            "Email support"
                                        ]}
                                        buttonLabel={
                                            currentPlanName === "Starter Plan"
                                                ? null
                                                : "Get Now"
                                        }
                                        onClick={() => {
                                            state?.USERID
                                                ? handleSubscriptionAndPayment(process.env.REACT_APP_STARTER_PLANID_INR, "Starter", 499)
                                                : dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                        }}
                                        badgeLabel={getBadge("Starter Plan")}
                                    />

                                    {/* Professional Plan */}
                                    <PricingCard
                                        bgClass="bg-card-light-blue"
                                        title="Professional Plan"
                                        price="Rs.999"
                                        subtitle="/year"
                                        items={[
                                            "Up to 3 Businesses",
                                            "Unlimited Invoices",
                                            "Unlimited Quotations",
                                            "Unlimited Proforma Invoices",
                                            "Unlimited Previews",
                                            "No BillNama branding",
                                            "WhatsApp Share & Signature",
                                            "Customer Ledger",
                                            "Priority support"
                                        ]}
                                        buttonLabel={
                                            currentPlanName === "Professional Plan"
                                                ? null
                                                : "Get Now"
                                        }
                                        onClick={() => {
                                            state?.USERID
                                                ? handleSubscriptionAndPayment(process.env.REACT_APP_PROFESSIONAL_PLANID_INR, "Professional", 999)
                                                : dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                        }}
                                        badgeLabel={getBadge("Professional Plan")}
                                    />

                                    {/* Agency Plan */}
                                    <PricingCard
                                        bgClass="bg-card-light-yellow"
                                        title="Agency Plan"
                                        price="Rs.1999"
                                        subtitle="/year"
                                        items={[
                                            "Add member & shared access",
                                            "Unlimited Businesses",
                                            "Unlimited Invoices",
                                            "Unlimited Quotations",
                                            "Unlimited Proforma Invoices",
                                            "Unlimited Previews",
                                            "No BillNama branding",
                                            "WhatsApp Share & Signature",
                                            "Customer Ledger",
                                            "Priority + WhatsApp support"
                                        ]}
                                        buttonLabel={
                                            currentPlanName === "Agency Plan"
                                                ? null
                                                : "Get Now"
                                        }
                                        onClick={() => {
                                            state?.USERID
                                                ? handleSubscriptionAndPayment(process.env.REACT_APP_AGENCY_PLANID_INR, "Agency", 1999)
                                                : dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                        }}
                                        badgeLabel={getBadge("Agency Plan")}
                                    />
                                </div>
                            </div>

                            {/* USD PLANS */}
                            <div
                                className={`tab-pane fade show ${activeTab === "USD" ? "active" : ""}`}
                                id="pills-monthly"
                                role="tabpanel"
                                aria-labelledby="pills-monthly-tab"
                                tabIndex={0}
                            >
                                <div className="row justify-content-center g-4">


                                    {/* Free Plan (UNCHANGED) */}
                                    <PricingCard
                                        bgClass="bg-card-light-pink"
                                        title="Free Plan"
                                        price="Free"
                                        subtitle=""
                                        items={[
                                            "1 Business",
                                            "2 invoices per month",
                                            "Unlimited expenses",
                                            "Limited invoice previews"
                                        ]}
                                        buttonLabel="Try for Free"
                                        onClick={() => navigate("/dashboard")}
                                    />

                                    {/* Starter Plan */}
                                    <PricingCard
                                        bgClass="bg-card-light-green"
                                        title="Starter Plan"
                                        price="$19.99"
                                        subtitle="/year"
                                        items={[
                                            "1 Business",
                                            "Unlimited Invoices",
                                            "Unlimited Quotations",
                                            "Unlimited Proforma Invoices",
                                            "Unlimited Previews",
                                            "BillNama Branding",
                                            "WhatsApp Share",
                                            "Customer Ledger",
                                            "Email support"
                                        ]}
                                        buttonLabel={currentPlanName === "Starter Plan" ? null : "Get Started"}
                                        onClick={() => {
                                            state?.USERID
                                                ? handleSubscriptionAndPayment(process.env.REACT_APP_STARTER_PLANID_USD, "Starter", 19.99)
                                                : dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                        }}
                                    />

                                    {/* Professional Plan */}
                                    <PricingCard
                                        bgClass="bg-card-light-blue"
                                        title="Professional Plan"
                                        price="$39.99"
                                        subtitle="/year"
                                        items={[
                                            "Up to 3 Businesses",
                                            "Unlimited Invoices",
                                            "Unlimited Quotations",
                                            "Unlimited Proforma Invoices",
                                            "Unlimited Previews",
                                            "No BillNama branding",
                                            "WhatsApp Share & Signature",
                                            "Customer Ledger",
                                            "Priority support"
                                        ]}
                                        buttonLabel={currentPlanName === "Professional Plan" ? null : "Get Started"}
                                        onClick={() => {
                                            state?.USERID
                                                ? handleSubscriptionAndPayment(process.env.REACT_APP_PROFESSIONAL_PLANID_USD, "Professional", 39.99)
                                                : dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                        }}
                                    />

                                    {/* Agency Plan */}
                                    <PricingCard
                                        bgClass="bg-card-light-yellow"
                                        title="Agency Plan"
                                        price="$79.99"
                                        subtitle="/year"
                                        items={[
                                            "Add member & shared access",
                                            "Unlimited Businesses",
                                            "Unlimited Invoices",
                                            "Unlimited Quotations",
                                            "Unlimited Proforma Invoices",
                                            "Unlimited Previews",
                                            "No BillNama branding",
                                            "WhatsApp Share & Signature",
                                            "Customer Ledger",
                                            "Priority + WhatsApp support"
                                        ]}
                                        buttonLabel={currentPlanName === "Agency Plan" ? null : "Get Now"}
                                        onClick={() => {
                                            state?.USERID
                                                ? handleSubscriptionAndPayment(process.env.REACT_APP_AGENCY_PLANID_USD, "Agency", 79.99)
                                                : dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                        }}
                                    />

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="container text-center py-3">
                <a
                    href='https://www.billnama.com/privacy-policy/'
                    target="_blank"
                >
                    <p class="small mb-0 text-decoration-underline">
                        Terms and Privacy Policy
                    </p>
                </a>
            </div>
        </div>
    )
}

export default PricingPlanLayer